import { render, staticRenderFns } from "./MedicaidWrapper.vue?vue&type=template&id=ae88b0c4"
import script from "./MedicaidWrapper.vue?vue&type=script&lang=js"
export * from "./MedicaidWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae88b0c4')) {
      api.createRecord('ae88b0c4', component.options)
    } else {
      api.reload('ae88b0c4', component.options)
    }
    module.hot.accept("./MedicaidWrapper.vue?vue&type=template&id=ae88b0c4", function () {
      api.rerender('ae88b0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicaid/MedicaidWrapper.vue"
export default component.exports